module.exports = __webpack_public_path__ + "img/zw.1225e561.jpg";